import React from 'react';
import classNames from 'classnames';

class CfButton extends React.Component {
    render() {
        const { className, ...rest } = this.props;

        return (
            <button className={classNames('cf-button', className)} {...rest}>
                {this.props.children}
            </button>
        );
    }
}

export default CfButton;



// WEBPACK FOOTER //
// ./components/HeaderSlider/Slide/CfButton/CfButton.jsx